import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    postcodeLookupWrapperContainer: {
      border: `2px solid ${theme.palette.primary.main}`,
      borderRadius: '5px',
      maxWidth: '40rem',
      marginBottom: '3rem',
      '& h3': {
        marginBottom: '2rem',
      },
    },
    postcodeLookupGrid: {
      padding: '2rem 2rem',
    },

    bottomHighlight: {
      padding: '0rem 1.25rem',
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.secondary.dark,
    },
    postcodeLabel: {
      ...theme.form.labels.inputField.label,
      color: theme.palette.dark[800],
      marginBottom: '1rem',
    },
    lookupContainer: {
      display: 'flex',
      '@media (max-width: 500px)': {
        flexDirection: 'column',
      },
    },
    lookupBtn: {
      marginLeft: '2rem',
      maxWidth: '11rem',
      '@media (max-width: 500px)': {
        marginTop: '1rem',
        marginLeft: '0rem',
      },
      '@media (max-width: 767px)': {
        maxWidth: '100%',
      },
    },
    minWidth14: {
      minWidth: '14rem',
    },
  }),
  { index: 1 },
);
